function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "text-/-text_align_center",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "edit-/-text_align_center"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "edit-/-text_align_center-(Background/Mask)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21,5 L3,5 L3,7 L21,7 L21,5 Z M18,11 L6,11 L6,9 L18,9 L18,11 Z M21,13 L3,13 L3,15 L21,15 L21,13 Z M18,17 L6,17 L6,19 L18,19 L18,17 Z",
  fill: "#555555",
  mask: "url(#mask-2)"
})));

function SvgTextAlignCenter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "text / text_align_center") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextAlignCenter);
export default __webpack_public_path__ + "static/media/text_align_center.51ae0f4a.svg";
export { ForwardRef as ReactComponent };